import type { ThemePreference } from "@prisma/design-tokens";

import { safeStorageGet, safeStorageSet } from "../i18n";

const KEY = "prisma.theme";

export function getThemePreference(): ThemePreference {
  const v = safeStorageGet(KEY);
  return v === "light" || v === "dark" ? v : "system";
}

/** System is the default: no data-theme attribute, tokens follow prefers-color-scheme. */
export function applyTheme(pref: ThemePreference): void {
  const root = document.documentElement;
  if (pref === "system") delete root.dataset.theme;
  else root.dataset.theme = pref;
  safeStorageSet(KEY, pref);
}

export function effectiveTheme(pref: ThemePreference): "light" | "dark" {
  if (pref !== "system") return pref;
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
